import { render, staticRenderFns } from "./contact-menu.vue?vue&type=template&id=2d100e9f&scoped=true&"
import script from "./contact-menu.vue?vue&type=script&lang=js&"
export * from "./contact-menu.vue?vue&type=script&lang=js&"
import style0 from "./contact-menu.vue?vue&type=style&index=0&id=2d100e9f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d100e9f",
  null
  
)

export default component.exports